import { Component, OnInit } from '@angular/core';
import { QueryConditionPropertyEditorBase } from '../../types/property-editor.types';
import { SelectConditionViewModel } from '../../types/query-condition';

@Component({
  selector: 'df-select-condition-property-editor',
  templateUrl: './select-condition-property-editor.component.html',
  styleUrls: ['./select-condition-property-editor.component.css']
})
export class SelectConditionPropertyEditorComponent extends QueryConditionPropertyEditorBase<SelectConditionViewModel>
  implements OnInit {
  get entityAttribute(): string {
    return this._entityAttribute;
  }
  set entityAttribute(val: string) {
    this._entityAttribute = val;
    this.afterSetControlValue(null);
  }
  get templateType(): string {
    return this._templateType;
  }
  set templateType(val: string) {
    this._templateType = val;
    this.afterSetControlValue(null);
  }
  _entityAttribute: string;
  _templateType: string;

  constructor() {
    super();
  }

  ngOnInit() {
    super.ngOnInit();
  }

  afterSetControlValue(value: any) {
    if (this.checked) {
      this.valueChange.emit({
        checked: this.checked,
        serialNo: this.serialNo,
        rule: this.rule,
        entityAttribute: this.entityAttribute,
        templateType: this.templateType
      });
    } else {
      this.valueChange.emit({ checked: this.checked });
    }
  }

  afterControlValueInit() {
    if (!this.value) {
      this.value = {};
    }
    this.checked = this.value.checked;
    this.serialNo = this.value.serialNo ? this.value.serialNo : 1;
    this.rule = this.value.rule ? this.value.rule : 'eq';
    this.entityAttribute = this.value.entityAttribute;
    this.templateType = this.value.templateType;
    this.setSingleAttribute();
  }

  afterEntityAttributeChange() {
    const checkedAttr = this.entityAttributesSetting.items.find((s) => s.name === this.entityAttribute);
    if (checkedAttr && checkedAttr.name) {
      this.entityAttribute = null;
    }
    this.setSingleAttribute();
  }

  /**
   * å½åå±æ§æ¶é»è®¤æ¥è¯¢å­æ®µ
   *
   * @memberOf SelectConditionPropertyEditorComponent
   */
  setSingleAttribute() {
    if (this.entityAttributesSetting.items.length === 2) {
      const first = this.entityAttributesSetting.items[1];
      if (first) {
        this.entityAttribute = first[this.entityAttributesSetting.valueMember];
      }
    }
  }
}
